import clsx from 'clsx'
import React, { ReactNode } from 'react'

import s from './styles.module.scss'

import { Transport_Type } from '../../../../../lib/graphql'

interface IHouseSearchTransportTypeProps {
  disabled: boolean
  labelDriving?: ReactNode
  labelTransit?: ReactNode
  onClick: (type: Transport_Type) => void
  value: Transport_Type
}

export const HouseSearchTransportType = ({
  labelDriving,
  labelTransit,
  disabled,
  value,
  onClick,
}: IHouseSearchTransportTypeProps) => {
  return (
    <div className={s.container}>
      <div className={s.switch}>
        <div
          className={clsx(s.leftSwitch, {
            [s.selected]: value === Transport_Type.DRIVING && !disabled,
            [s.disabled]: disabled,
          })}
          onClick={() => {
            if (value !== Transport_Type.DRIVING) {
              onClick(Transport_Type.DRIVING)
            }
          }}
        >
          {labelDriving}
        </div>
        <div
          className={clsx(s.rightSwitch, {
            [s.selected]: value === Transport_Type.TRANSIT && !disabled,
            [s.disabled]: disabled,
          })}
          onClick={() => {
            if (value !== Transport_Type.TRANSIT) {
              onClick(Transport_Type.TRANSIT)
            }
          }}
        >
          {labelTransit}
        </div>
      </div>
    </div>
  )
}
